import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetCheckinEntryForFinishConfirmModalDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { checkinFinishConfirmModalModalState } from '~/state/reception/atoms';

export const useGetCheckinEntryProfile = () => {
  const { isOpen, checkinEntryId } = useAtomValue(checkinFinishConfirmModalModalState);
  const [getCheckinEntryProfile, { data }] = useLazyQuery(
    GetCheckinEntryForFinishConfirmModalDocument,
  );
  const checkinEntry = getNode(data, 'CheckinEntry');

  useEffect(() => {
    if (isOpen && checkinEntryId) {
      getCheckinEntryProfile({ variables: { id: checkinEntryId } });
    }
  }, [isOpen, checkinEntryId, getCheckinEntryProfile]);

  return { checkinEntry };
};
